import React from 'react';
import { ReactComponent as FigUsers01Component } from './FigUsers01.svg';

const FigUsers01 = (props) => <FigUsers01Component {...props} />;

export default FigUsers01;
